import { type QueryClient, useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApiMutation';
import type { ApiError } from '@/lib/api/errors';

interface CreateMutationHookConfig<TData, TVariables> {
  mutationFn: (variables: TVariables) => Promise<TData>;
  onSuccess?: (data: TData, variables: TVariables, queryClient: QueryClient) => void;
  onError?: (error: ApiError, variables: TVariables, queryClient: QueryClient) => void;
  showErrorToast?: boolean;
}

export function createMutationHook<TData, TVariables = void>({
  mutationFn,
  onSuccess,
  onError,
  showErrorToast,
}: CreateMutationHookConfig<TData, TVariables>) {
  return function useGeneratedMutation() {
    const queryClient = useQueryClient();

    return useApiMutation<TData, TVariables>({
      mutationFn,
      showErrorToast,
      onSuccess: (data, variables) => {
        onSuccess?.(data, variables, queryClient);
      },
      onError: (error, variables) => {
        onError?.(error, variables, queryClient);
      },
    });
  };
}
